/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { FunctionComponent, JSX } from "react";

import carouselArrowActive from "../../../model/assets/images/carousel_arrow_active.svg";
import carouselArrowInactive from "../../../model/assets/images/carousel_arrow_inactive.svg";
import type { CarouselArrowProps } from "./CarouselArrowProps";

/**
 * CarouselArrow renders a circular navigation button using Figma-exported SVG assets.
 * The active SVG (white circle, dark chevron) and inactive SVG (dark circle, white chevron)
 * are flipped via CSS scaleX(-1) for the left direction.
 * Browser-only component — not rendered on SmartTV devices.
 */
const CarouselArrow: FunctionComponent<CarouselArrowProps> = (
  props: CarouselArrowProps
): JSX.Element => {
  const { direction, isDisabled, onClick } = props;

  const modifier: string = isDisabled
    ? "carousel-arrow--inactive"
    : "carousel-arrow--active";

  const directionModifier: string =
    direction === "left" ? "carousel-arrow--left" : "carousel-arrow--right";

  const iconSrc: string = isDisabled
    ? carouselArrowInactive
    : carouselArrowActive;

  return (
    <button
      className={"carousel-arrow " + modifier + " " + directionModifier}
      type="button"
      aria-label={
        direction === "left" ? "Scroll carousel left" : "Scroll carousel right"
      }
      disabled={isDisabled}
      onClick={onClick}
    >
      <img
        className="carousel-arrow__icon"
        src={iconSrc}
        alt=""
        aria-hidden="true"
        draggable={false}
      />
    </button>
  );
};

export default CarouselArrow;
